const distances = {
  pageMarginBig: 20,
  gap: 20,
  sectionMarginBig: 120,
}

export default distances
